export default __webpack_public_path__ + "static/media/challenge-end.7380cca7.mp3";